import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import ImportLogService from '../../services/ImportLogService';

const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
    }
};
export const fetchImportLog = createAsyncThunk('importLog', async () => {
    const response = await ImportLogService.getImportLog();
    return response;
});
export const ImportLogSlice = createSlice({
    name: 'importLog',
    initialState,
    reducers: {
        addImportLogColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToImportLogColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchImportLog.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchImportLog.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addImportLogColumnConfig, addColumnToImportLogColumnConfig } =
ImportLogSlice.actions;

export const selectImportLog = (state) => {

    return state.importLog.data
};

export const selectImportLogColumnConfig = (state) =>
    state.importLog.columnConfig;

export default ImportLogSlice.reducer;